const getTokenData = (authState) => {
  const { token } = authState;
  // const needCookStr = document.cookie.split(';').find(t => t.indexOf('session=') !== -1);
  const needCookStr = document.cookie
    .split(';')
    .map(item => item.trim())
    .find(t => t.startsWith('session='));
  const needCook = needCookStr?.replace('session=', '');

  return {
    token,
    projectName: 'x10tn',
    needCook,
  };
};

export default getTokenData;